import { render, staticRenderFns } from "./AdminIncidents.vue?vue&type=template&id=06c104f6&"
import script from "./AdminIncidents.vue?vue&type=script&lang=js&"
export * from "./AdminIncidents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports